(function () {
  'use strict';
  if (window.__ncKartenSwipe) return;
  window.__ncKartenSwipe = true;

  document.addEventListener('click', function (e) {
    var pfeil = e.target.closest ? e.target.closest('[data-nc-ks-pfeil]') : null;
    if (!pfeil) return;
    var fig = pfeil.closest('.product-card__figure');
    var strip = fig && fig.querySelector('[data-nc-ks]');
    if (!strip) return;
    strip.scrollBy({ left: strip.clientWidth * Number(pfeil.getAttribute('data-nc-ks-pfeil')), behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (e) {
    var strip = e.target;
    if (!strip || strip.nodeType !== 1 || !strip.hasAttribute('data-nc-ks') || strip.__ncKsTick) return;
    strip.__ncKsTick = true;
    requestAnimationFrame(function () {
      strip.__ncKsTick = false;
      var fig = strip.closest('.product-card__figure');
      if (!fig) return;
      var i = Math.round(strip.scrollLeft / (strip.clientWidth || 1));
      fig.querySelectorAll('.nc-ks__punkt').forEach(function (punkt, n) {
        punkt.classList.toggle('nc-ks__punkt--aktiv', n === i);
      });
      var ende = strip.scrollWidth - strip.clientWidth - 2;
      fig.querySelectorAll('[data-nc-ks-pfeil]').forEach(function (knopf) {
        var vor = knopf.getAttribute('data-nc-ks-pfeil') === '1';
        knopf.disabled = vor ? strip.scrollLeft >= ende : strip.scrollLeft <= 1;
      });
    });
  }, true);

  if (
    'IntersectionObserver' in window &&
    window.matchMedia('(hover: none)').matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    var gestupst = false;
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (eintrag) {
        if (!eintrag.isIntersecting || gestupst) return;
        gestupst = true;
        eintrag.target.classList.add('nc-ks--stups');
        beobachter.disconnect();
      });
    }, { threshold: 0.6 });
    var erste = document.querySelector('[data-nc-ks]');
    if (erste) beobachter.observe(erste);
  }
})();
